import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const DialogOverlay = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
`;

const DialogContent = styled.div`
    position: relative;
    width: 520px;
    background: #ffffff;
    box-shadow: 0px 0px 24px rgb(0 0 0 / 18%);
    border-radius: 8px;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    padding: 20px;
`;

const DialogTitle = styled.div`
    font-weight: bold;
    font-size: 24px;
    padding: 20px;
`;

const DialogText = styled.p`
    font-weight: 500;
    font-size: 16px;
    padding: 0px 20px 20px;
    margin: 0;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    padding: 20px;
`;

const Button = styled.div`
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    height: 50px;
    width: 216px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    &.secondary {
        background: ${props => props.theme.colors.gray};
    }
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
`;

const Backdrop = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    zindex: 999;
    background: #2b2b32;
    opacity: 0.8;
`;
export const SavedGameDialog = ({ open, onClose, onStartGame, onContinueGame }) => {
    const [showConfirmation, setShowConfirmation] = React.useState(false);
    const { t } = useTranslation();

    const handleStartNewGame = () => {
        setShowConfirmation(true);
    };

    const handleConfirmNewGame = () => {
        setShowConfirmation(false);
        onStartGame();
        onClose();
    };

    const handleContinueSavedGame = () => {
        // Call onContinueGame to restore saved game (without forceNewGame)
        if (onContinueGame) {
            onContinueGame();
        } else {
            // Fallback to onStartGame if onContinueGame not provided
            onStartGame();
        }
        onClose();
    };

    if (!open) return null;

    return (
        <>
            {/* Main Dialog */}
            {!showConfirmation && (
                <DialogOverlay>
                    <DialogContent>
                        <DialogTitle>{t('modals.saved_game.info_title')}</DialogTitle>
                        <p>{t('modals.saved_game.info_text')}</p>
                        <ButtonContainer>
                            <Button onClick={handleContinueSavedGame}>
                                {t('modals.saved_game.button2')}
                            </Button>
                            <Button className="primary" onClick={handleStartNewGame}>
                                {t('modals.saved_game.button1')}
                            </Button>
                        </ButtonContainer>
                    </DialogContent>
                </DialogOverlay>
            )}

            {/* Confirmation Dialog */}
            {showConfirmation && (
                <DialogOverlay>
                    <DialogContent>
                        <DialogTitle>{t('modals.new_game_confirmation.info_title')}</DialogTitle>
                        <p>{t('modals.new_game_confirmation.info_text')}</p>
                        <ButtonContainer>
                            <Button onClick={() => setShowConfirmation(false)}>
                                {t('modals.new_game_confirmation.button2')}
                            </Button>
                            <Button className="primary" onClick={handleConfirmNewGame}>
                                {t('modals.new_game_confirmation.button1')}
                            </Button>
                        </ButtonContainer>
                    </DialogContent>
                </DialogOverlay>
            )}
        </>
    );
};
